import { IBenhNhan, IMakeAnAppointment } from "../models/MakeAnAppointmentModels";

export const initialValuesBenhNhan: IBenhNhan = {
    person: {
        fullName: "",
        firstName: "",
        lastName: "",
        displayName: "",
        shortName: "",
        otherName: "",
        birthDate: "",
        birthPlace: "",
        dobDay: "",
        dobMonth: "",
        dobYear: "",
        gender: null,
        startDate: "",
        endDate: "",
        phoneNumber: "",
        idNumber: "",
        email: "",
        taxCode: "",
        ccountry: null
    },
    personCode: "",
    personName: "",
    allergyStatus: "text",
    code: "",
    ethnicity: null,
    phoneNumber: "",
    gender: "",
    idNumber: "",
    address: null,
    administrativeUnit: null,
    province: null,
    district: null,
    commune: null,
    occupation: null,
    appointmentDate: null,
    referrer: null,
    deleted: false,
    deletedBy: null,
    deletedDate: null,
    deletedReason: null
};

export const UU_TIEN = {
    TRUE: 0,
    FALSE: 1
};

export const initialValuesTiepDon: IMakeAnAppointment = {
    patient: initialValuesBenhNhan,
    orgProvideName: null,
    visit: {
        visitObjectType: null,
        visitType: null,
        visitReason: '',
        service: null,
        dept: null,
        attributes:null,
        sortWeight: UU_TIEN.FALSE,
    },
    orders: [],
};